import { render } from "./ProductList.vue?vue&type=template&id=2796e7d2&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=2796e7d2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2796e7d2"

export default script